import { Button as BaseButton, Checkbox } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import store from 'stores/RootStore';
import { SelectState } from 'types/SelectState';

const Button = styled(BaseButton)`
  padding: 0 10px;
`;

function SelectionCheckbox() {
  const adsManager = store.creative?.ads;

  const handleCheckToggle = () => {
    if (!adsManager) return;

    switch (adsManager.selectState) {
      case SelectState.ALL:
        adsManager.selectNone();
        break;
      case SelectState.PARTIAL:
      case SelectState.NONE:
        adsManager.selectAll();
        break;
    }
  };

  const selectionStatus = adsManager?.selectState;

  return (
    <Button disabled={!adsManager} onClick={handleCheckToggle}>
      <Checkbox
        checked={selectionStatus === SelectState.ALL}
        indeterminate={selectionStatus === SelectState.PARTIAL}
      />
    </Button>
  );
}

export default observer(SelectionCheckbox);
